export default __webpack_public_path__ + "static/media/junkrat-intro.425041e9.mp3";